<template>
  <div>
    <search v-if="searchDisable !== true" v-model="search" />

    <add-item-full
      v-if="isAddFull && fields && fields.length && setLink"
      :openItem="openItem"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />

    <div class="filters">
      <div v-for="dFilter in dateFilter" :key="dFilter.key">
        <label
          >{{ dFilter.titleKey | setText(dFilter.title) }}
          <span
            v-show="params[dFilter.key]"
            @click="params[dFilter.key] = null"
            class="link"
            >{{ "reset" | setText("сбросить") }}</span
          ></label
        >
        <datetime
          v-model="params[dFilter.key]"
          @input="params['page'] = 1"
          class="from-control"
          type="date"
          format="dd/MM/yyyy"
        ></datetime>
      </div>
      <template v-for="f in staticFilters">
        <div
          :key="f.key"
          v-if="(!f.shop || shop) && (!f.is_root || user['is_root'])"
        >
          <label>{{ f.titleKey | setText(f.title) }}</label>
          <select
            @change="params['page'] = 1"
            v-model="params[f.key]"
            class="form-control"
          >
            <option :value="v.id" v-for="(v, vK) in f.items" :key="vK">
              {{ v.title }}
            </option>
          </select>
        </div>
      </template>
      <div v-for="filter in filters" :key="filter.key">
        <filter-item
          :modal="filter.key"
          :title="filter.title"
          :single="filter.single"
          :params="filter['params']"
          :titleKey="filter.titleKey"
          :selectKey="filter.selectKey"
          v-model="
            params[`${filter.field_key ? filter.field_key : filter.key}_id`]
          "
          @input="params['page'] = 1"
        />
      </div>
    </div>
    <div
      :class="` position-relative overflow-hidden ${loading ? 'loading' : ''}`"
    >
      <div
        v-if="
          (value.length && !simple) ||
          isAdd ||
          is_filter ||
          isUpdate ||
          setImport === true ||
          (functions && functions.length && value.length)
        "
        class="row"
      >
        <div class="col-12">
          <ul class="status">
            <li v-if="import_products && shop && user['is_root']">
              <import-products></import-products>
            </li>
            <li v-if="re_paymart && user['is_root']">
              <re-paymart :itemLink="itemLink" :params="params"></re-paymart>
            </li>
            <li v-if="isAdd">
              <button class="btn btn-info btn-icon" @click="addItem">
                <span class="ti-plus"></span>
                {{ title_add_key | setText(title_add) }}
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>

            <li v-if="isUpdate">
              <button class="btn" @click="getList">
                <span class="ti-reload"></span>
                {{ "refresh" | setText("Обновить") }}
              </button>
            </li>
            <li v-if="setImport === true">
              <button class="btn btn-icon" @click="exportExcel">
                <span class="ti-upload"></span>
                to EXCEL
              </button>
            </li>
            <li v-if="functions && functions.length && value.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="value.length && !simple">
              <button class="btn btn-warning btn-icon" @click="val = []">
                <span class="ti-close"></span>
                Сброить {{ value.length }}
              </button>
            </li>

            <li v-if="projectInfo">
              <button
                class="btn btn-danger"
                @click="getProjectInfo(projectInfo)"
              >
                <span class="ti-info"></span>
                {{ "how_work" | setText("Как работает сервис") }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <ul v-if="!simple" class="selected-items">
        <li v-for="v in value" :key="v.id">
          <span>{{ v[checkSelect] }}</span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div class="row" v-if="columns && columns.length && items">
        <div class="col-12">
          <div class="table-full-width table-responsive">
            <paper-table
              :additionalId="additionalId"
              v-show="items.data.length"
              type="hover"
              :simple="simple"
              :card="cardLink"
              :cardLink="cardLink"
              :data="items.data"
              :columns="columns"
              :removeItem="removeItem"
              v-model="val"
              :dataObject="dataObject"
              :current_page="items.current_page"
              @sortby="sortby"
            ></paper-table>
            <h6 v-if="items.data.length === 0">
              <hr />
              {{ "empty_data_" | setText("В списке нет данных") }}
            </h6>

            <div
              v-if="!hidePageInfo && items.last_page && items.total"
              class="badge badge-danger"
            >
              {{ "total" | setText("Всего") }}
              {{ items.last_page ? ": " + items.total + "" : "..." }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          !hidePageInfo &&
          (items.last_page > 1 || items.last_page > items.current_page)
        "
        class="fixed-pagination"
      >
        <div class="responsive-pagination">
          <paginate
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'<'"
            :nextText="'>'"
          ></paginate>
        </div>
      </div>
    </div>

    <export-excel
      :exportFields="exportFields"
      :itemLink="itemLink"
      :params="params"
    />
    <add-item
      :openItem="openItem"
      @close="add = false"
      v-if="isAdd && fields && fields.length && setLink && add === true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import Search from "./Search";
import ImportProducts from "@/components/ImportProducts";
import RePaymart from "@/components/RePaymart";
import { mapState } from "vuex";
import { errorNotify } from "../plugins/functions";
export default {
  name: "List",
  data() {
    return {
      add: false,
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
      dataObject: {},
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        data: [],
      },
    };
  },
  components: {
    PaperTable,
    ImportProducts,
    RePaymart,
    Search,
    "add-item": () => import("./Modals/AddItem"),
    "add-item-full": () => import("./Modals/AddItemFull"),
    "export-excel": () => import("@/components/ExportExcel"),
  },

  props: {
    projectInfo: {
      default: null,
    },
    createLog: {
      default: null,
    },
    isAddFull: {
      default: false,
    },
    additionalId: {
      default: null,
    },
    openItem: {
      default: true,
    },
    re_paymart: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
    exportFields: {
      default: function () {
        return {};
      },
    },
    searchDisable: {},
    setLink: {},
    itemLink: {},
    title: {},
    simple: {
      default: false,
    },
    import_products: {
      default: false,
    },
    hidePageInfo: {
      default: false,
    },
    setImport: {
      default: false,
    },
    columns: {},
    removeLink: {},
    cardLink: {},
    modalCreate: {},
    disable_add: {},
    is_filter: {},
    isAdd: {},
    isUpdate: {},
    functions: {},
    fields: {},
    params: {
      default: function () {
        return {};
      },
    },
    title_add: {
      default: function () {
        return "Добавить новый";
      },
    },
    title_add_key: {
      default: function () {
        return "add_new";
      },
    },
    filters: {
      default: function () {
        return [];
      },
    },
    staticFilters: {
      default: function () {
        return [];
      },
    },
    dateFilter: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    checkSelect() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].checkbox === true) {
          return this.columns[i].key;
        }
      }
      return null;
    },
    ...mapState(["newOrder", "lastUpdate", "user", "shop"]),
    page() {
      return this.items.current_page;
    },
    val: {
      get() {
        //console.log('dddd', this.value);
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val) {
      if (val) {
        //console.log('LAST UPDATE');
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    getProjectInfo(id) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_info_project_info_flow"] == id) {
        return false;
      }

      if (query["item_info_project_info_flow"]) {
        delete query["item_info_project_info_flow"];
      }

      query["item_info_project_info_flow"] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },

    exportExcel() {
      this.$modal.show("export");
    },
    clearFilter() {
      this.$emit("clearFilter", true);
    },
    sortby(val) {
      this.sort = val;
      this.getList();
    },
    addItem() {
      this.add = true;
    },
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    removeItem(itemID) {
      this.$dialog
        .confirm(this.$store.state.text.sure_delete, {
          okText: this.$store.state.text.delete,
          cancelText: this.$store.state.text.cancel,
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.itemLink}/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.$emit("deleted", true);
              this.$store.dispatch("setLastUpdate", new Date());
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getList(loading = true, resetPage = false) {
      let params = this.params ? this.params : {};
      params["page"] = this.items.current_page;
      params["search"] = this.search;
      params["order"] = `${this.sort.orderType === "DESC" ? "" : "-"}${
        this.sort.orderBy
      }`;
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage === true) {
        params["page"] = 1;
      }
      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data) {
            this.items.data = response.data.data;
            this.items.total = response.data.meta.total;
            const perPage = response.data.meta.per_page;
            this.items.last_page = Math.ceil(this.items.total / perPage);
            if (response.data.data) {
              let data = response.data.data;
              for (let i = 0; i < this.value.length; i++) {
                this.dataObject[this.value[i].id] = this.value[i];
              }
              for (let i = 0; i < data.length; i++) {
                this.dataObject[data[i].id] = data[i];
              }
            }
          }
          if (response.data.type) {
            this.$emit("type", response.data.type);
          }
        })
        .catch(() => {
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },

    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss">
ul.selected-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  overflow-x: scroll;
  max-width: 100%;

  @media (min-width: 769px) {
    flex-wrap: wrap;
  }

  & > li {
    max-width: 180px;
    border-radius: 5px;
    margin-right: 10px;
    background: #000511;
    color: #fff;
    font-size: 10px;
    margin-bottom: 10px;
    padding: 4px 6px;
    display: flex;

    & > span {
      display: block;

      &:last-child {
        font-size: 8px;
        margin-left: 10px;
        cursor: pointer;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
